module.exports = __webpack_public_path__ + "media/images/users/avatar-3-65d1a00a62eb73558a7251389332cd07.jpg";